<template>
  <ul class="nav nav-pills flex-column mb-auto align-items-start pt-lg-7"
      id="menu"
      :style="appStyleProps">
    <!-- If current App is SBA, show sba navItems nested within MP navItems -->
    <div v-if="isCurrentAppSBA">
      <!-- MP navlinks minus submit -->
      <TransitionGroup name="fade-drag">
        <li v-for="(navItem, index) in mpFilteredNavList"
            :key="navItem.name"
            class="nav-item"
            :class="{'customized-affiliate': !!affiliateCustomizations}">
          <nuxt-link
            v-if="isMounted && navItem.isComplete"
            :to="primaryRoute(navItem)"
            class="nav-link px-0 text-success completed-nav-item"
            :class="{
              currentPage: navRouteMatchesCurrentRoute(navItem),
              'customized-affiliate': !!affiliateCustomizations
            }"
          >
            <div class="align-top completed-nav-icon-circle" :class="{'customized-affiliate': !!affiliateCustomizations}">
              <font-awesome-icon :icon="faCheck" class="fa-check"></font-awesome-icon>
            </div>
            <span class="nav-text ms-2 align-middle" :class="{'customized-affiliate': !!affiliateCustomizations}">{{navItem.title}}</span>
          </nuxt-link>
          <nuxt-link
            v-else
            :to="primaryRoute(navItem)"
            class="nav-link nav-item px-0"
            :event="!navItem.visited ? null : 'click'"
            :class="{
              currentPage: navRouteMatchesCurrentRoute(navItem),
              disabled: !navItem.visited,
              'customized-affiliate': !!affiliateCustomizations
            }"
          >
            <span class="nav-icon-circle d-inline-block position-relative rounded-circle align-top">
              <span class="nav-number p-xs position-absolute start-50 top-50">{{index+1}}</span>
            </span>
            <span class="nav-text ms-2 align-middle">
              {{navItem.title}}
            </span>
          </nuxt-link>
        </li>
      </TransitionGroup>
      <!-- NESTED SUBLIST FOR SBA -->
      <TransitionGroup name="fade-drag">
        <li v-for="(navItem, index) in navList"
            :key="navItem.name"
            class="nav-item nav-subitem ps-5"
            :class="{
              'customized-affiliate': !!affiliateCustomizations
            }"
        >
          <nuxt-link
            v-if="isMounted && navItem.isComplete"
            :to="primaryRoute(navItem)"
            class="nav-link px-0 text-success completed-nav-item"
            :class="{
              currentPage: navRouteMatchesCurrentRoute(navItem),
              'customized-affiliate': !!affiliateCustomizations
            }"
          >
            <div class="align-top completed-nav-icon-circle-sba">
              <font-awesome-icon :icon="faCheck" class="fa-check"></font-awesome-icon>
            </div>
            <span class="nav-text ms-2 align-middle">{{navItem.title}}</span>
          </nuxt-link>
          <nuxt-link
            v-else
            :to="primaryRoute(navItem)"
            class="nav-link nav-item px-0"
            :event="!navItem.visited ? null : 'click'"
            :class="{
              currentPage: navRouteMatchesCurrentRoute(navItem),
              disabled: !navItem.visited,
              'customized-affiliate': !!affiliateCustomizations
            }"
          >
            <span class="nav-icon-circle-sba d-inline-block position-relative rounded-circle align-top">
              <span class="nav-number p-xs position-absolute start-50 top-50">{{index+1}}</span>
            </span>
            <span class="nav-text ms-2 align-middle">
              {{navItem.title}}
            </span>
          </nuxt-link>
        </li>
      </TransitionGroup>
      <!-- Show Submit only below SBA navItems -->
      <TransitionGroup name="fade-drag">
        <li v-for="(navItem, index) in mpFilteredNavListSubmitOnly"
            :key="navItem.name"
            class="nav-item"
            :class="{
              'customized-affiliate': !!affiliateCustomizations
            }"
        >
          <nuxt-link
            v-if="isMounted && navItem.isComplete"
            :to="primaryRoute(navItem)"
            class="nav-link px-0 text-success completed-nav-item"
            :class="{
              currentPage: navRouteMatchesCurrentRoute(navItem),
              'customized-affiliate': !!affiliateCustomizations
            }"
          >
            <div class="align-top completed-nav-icon-circle">
              <font-awesome-icon :icon="faCheck" class="fa-check"></font-awesome-icon>
            </div>
            <span class="nav-text ms-2 align-middle">{{navItem.title}}</span>
          </nuxt-link>
          <nuxt-link
            v-show="isMounted && !navItem.isComplete"
            :to="primaryRoute(navItem)"
            class="nav-link nav-item px-0"
            :event="!navItem.visited ? null : 'click'"
            :class="{
              currentPage: navRouteMatchesCurrentRoute(navItem),
              disabled: !navItem.visited,
              'customized-affiliate': !!affiliateCustomizations
            }"
          >
            <span class="nav-icon-circle d-inline-block position-relative rounded-circle align-top">
              <span class="nav-number p-xs position-absolute start-50 top-50">{{index+5}}</span>
            </span>
            <span class="nav-text ms-2 align-middle">
              {{navItem.title}}
            </span>
          </nuxt-link>
        </li>
      </TransitionGroup>
    </div>
    <!-- Show normal navList for MP app -->
    <div v-else>
      <Transition name="fade-drag">
        <div v-if="!navList || navList.length === 0" class="position-absolute">
          <div class="loading-skeleton my-2">
            <div class="d-flex mb-4" v-for="(item, index) in mpPlaceholderItems" :key="item.placeholder">
              <div class="load-box skel-300 load-circle rounded-5 me-2">{{ index + 1 }}</div>
              <div class="load-box skel-300 px-5 rounded">{{ item.placeholder }}</div>
            </div>
          </div>
        </div>
      </Transition>
      <TransitionGroup name="fade-drag">
        <li v-for="(navItem, index) in navList"
          :key="navItem.name"
          class="nav-item"
          :class="{'customized-affiliate': !!affiliateCustomizations}">
          <nuxt-link
            v-show="isMounted && navItem.isComplete"
            :to="primaryRoute(navItem)"
            class="nav-link px-0 text-success completed-nav-item"
            :class="{
              currentPage: navRouteMatchesCurrentRoute(navItem),
              'customized-affiliate': !!affiliateCustomizations
            }"
          >
            <div class="align-top completed-nav-icon-circle" :class="{'customized-affiliate': !!affiliateCustomizations}">
              <font-awesome-icon :icon="faCheck" class="fa-check"></font-awesome-icon>
            </div>
            <span class="nav-text ms-2 align-middle" :class="{'customized-affiliate': !!affiliateCustomizations}">{{navItem.title}}</span>
          </nuxt-link>
          <nuxt-link
            v-show="isMounted && !navItem.isComplete"
            :to="primaryRoute(navItem)"
            class="nav-link nav-item px-0"
            :event="!navItem.visited ? null : 'click'"
            :class="{
              currentPage: navRouteMatchesCurrentRoute(navItem),
              disabled: !navItem.visited,
              'customized-affiliate': !!affiliateCustomizations
            }"
          >
            <span class="nav-icon-circle d-inline-block position-relative rounded-circle align-top"
                  :class="{'customized-affiliate': !!affiliateCustomizations}">
              <span class="nav-number p-xs position-absolute start-50 top-50">{{index+1}}</span>
            </span>
            <span class="nav-text ms-2 align-middle" :class="{'customized-affiliate': !!affiliateCustomizations}">
              {{navItem.title}}
            </span>
          </nuxt-link>
        </li>
      </TransitionGroup>
    </div>
  </ul>
</template>

<script>
import { faCheck } from '@fortawesome/pro-regular-svg-icons'
import { useBorrowerStore } from '~/store/borrower'
import { mapState } from 'pinia'
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'
import { useProgressStore } from '~/store/progress'

export default {
  setup() {
    return { faCheck }
  },
  name: 'SidebarNavigation',
  data() {
    return {
      isMounted: false,
      mpPlaceholderItems: [
        { placeholder: 'Basic info' },
        { placeholder: 'Owner info' },
        { placeholder: 'Business info' },
        { placeholder: 'Documents' },
        { placeholder: 'Submit' },
      ]
    }
  },
  mounted() {
    this.isMounted = true
  },
  computed: {
    ...mapState(useAffiliateCustomizationStore, ['appStyleProps', 'affiliateCustomizations']),
    ...mapState(useProgressStore, ['currentApp', 'resolveAppNavList', 'marketplaceNavList', 'isCurrentAppSBA']),
    ...mapState(useBorrowerStore, ['borrower']),
    navList() {
      if (!this.isMounted) {
        return [] // By
      }
      return this.resolveAppNavList
    },
    mpFilteredNavList() {
      const appNavList = this.marketplaceNavList
      return this.currentApp.type === 'sba'
        ? appNavList.filter(nav => nav.name !== 'submit')
        : appNavList
    },
    mpFilteredNavListSubmitOnly() {
      const appNavList = this.marketplaceNavList
      return this.currentApp.type === 'sba'
        ? appNavList.filter(nav => nav.name === 'submit')
        : appNavList
    }
  },
  methods: {
    primaryRoute (navItem) {
      const route = navItem.routes.find(r => r.primary) || navItem.routes[0]
      return route && route.route
    },
    navRouteMatchesCurrentRoute(navItem) {
      const route = useRoute()
      return navItem.routes.map(r => r.route)
        .concat(navItem.adoptedRoutes || [])
        .some(r => (new RegExp(`^${r}/?$`)).test(route.path));
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/styles/affiliate-customizations/affiliate-customizations-sidenav';

.fade-drag-enter-active,
.fade-drag-leave-active {
  transition: all 0.3s ease-in-out;
}
.fade-drag-enter-from,
.fade-drag-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.nav-item {
  .nav-icon-circle, .nav-icon-circle-sba {
    top: 1px;
    width: 24px;
    height: 24px;
    color: $type-600;
    background: $white;
    border: 1px solid $type-600;
  }

  .nav-icon-circle-sba {
    width: 20px;
    height: 20px;
  }
  &.currentPage {
    .nav-icon-circle {
      color: $white;
      background: $black;
      border: none;
    }
    .nav-text {
      color: $type-600;
      font-weight: bold;
    }
  }
  &.nav-link {
    color: $type-600;
  }
  &.disabled {
    .nav-icon-circle {
      color: $neutral-600;
      border: 1px solid $neutral-600;
    }

    .nav-text {
      color: $type-400;
    }
  }

  &.customized-affiliate {
    @include affiliateCustomizedSidenav();
  }
}

.completed-nav-item {
  .completed-nav-icon-circle,  .completed-nav-icon-circle-sba {
    height: 24px;
    width: 24px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    font-weight: 900;
    background-color: $lime-200;
    color: $type-600;
    border-radius: 50%;
    border: 1px solid $lime-400;
  }

   .completed-nav-icon-circle-sba {
     height: 20px;
     width: 20px;
   }
  .nav-text {
    color: $black;
  }
  &.active {
    .nav-text {
      color: $black;
      font-weight: bold;
      opacity: 1;
    }
  }
  &.disabled {
    .nav-text {
      color: $type-300;
    }
  }
  &.currentPage {
    .nav-text {
      color: $black;
      font-weight: bold;
    }
  }
  &:hover > .nav-text {
    color: $type-500;
  }

  &.customized-affiliate {
    @include affiliateCustomizedSidenav();
  }
}
.nav-number {
  transform: translateX(-50%) translateY(-50%);
}
.nav-subitem{
  font-size: 14px;
}

.load-box {
  min-width: 25px;
  height: 25px;
}
</style>
